import { api } from "@/redux/api";

import {
	PersonLastSearch,
	PersonSearchDefaults,
	SearchDefaultsInfo,
	SearchDefaultsInfoSchema,
} from "./searchDefaults.schema";

/**
 * Search defaults (PREC-3666). Every write answers with the full state, which the slice takes
 * as it is — so no write invalidates the query and re-asks for what it was just told.
 */
export const searchDefaultsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getSearchDefaults: builder.query<SearchDefaultsInfo, void>({
			query: () => ({
				url: "search-defaults",
				responseSchema: SearchDefaultsInfoSchema,
			}),
			providesTags: ["SearchDefaults"],
		}),
		updateCompanySearchDefaults: builder.mutation<SearchDefaultsInfo, PersonSearchDefaults>({
			query: (body) => ({
				url: "search-defaults/company",
				method: "PUT",
				body,
				responseSchema: SearchDefaultsInfoSchema,
			}),
		}),
		regenerateCompanySearchDefaults: builder.mutation<SearchDefaultsInfo, void>({
			query: () => ({
				url: "search-defaults/company/regenerate",
				method: "POST",
				responseSchema: SearchDefaultsInfoSchema,
			}),
		}),
		saveLastPersonSearch: builder.mutation<SearchDefaultsInfo, PersonLastSearch>({
			query: (body) => ({
				url: "search-defaults/last-search",
				method: "PATCH",
				body,
				responseSchema: SearchDefaultsInfoSchema,
			}),
		}),
	}),
});

export const {
	useGetSearchDefaultsQuery,
	useUpdateCompanySearchDefaultsMutation,
	useRegenerateCompanySearchDefaultsMutation,
	useSaveLastPersonSearchMutation,
} = searchDefaultsApi;
